import { RuntimeModel, http } from '@kunlun/dependencies';
import { graphqlQueryFormatter } from '../../../../utils/serialize';

export const queryPage = async (rModel: RuntimeModel, params: { orderCode: string; purchasingPlanId: number }) => {
  const gql = `
    query {
      deliAriesSellerPurchasingPlanDetailQuery {
        constructOnAdd(
          detail :{ 
            orderCode : "${params.orderCode}"
            purchasingPlanId: ${params.purchasingPlanId}
          }
        ) 
        {
          id
          itemId
          tradeDetailId
          skuId
          packageUnit
          validateMsg
          itemOutCode
          itemCode
          itemName
          productOutCode
          materialGroupCode
          isMsItem
          isGifted
          isAllocItem
          orderItemNum
          saleUnitName
          purchasingTotalNum
          unPurchasingTotalNum
          itemPurchasingNum
          unItemPurchasingNum
          itemShippedNum
          itemUnShippedNum
          itemSpecifications {
            id
            unitName
            unitCode
            conversionRules
            count
            pcsCount
          }
        }
      }
    }
  `;
  const res = await http.query<any>(rModel.moduleName, graphqlQueryFormatter(gql));

  return res.data.deliAriesSellerPurchasingPlanDetailQuery.constructOnAdd;
};
